import { render, staticRenderFns } from "./stock-order-all.vue?vue&type=template&id=4252f952&scoped=true"
import script from "./stock-order-all.vue?vue&type=script&lang=js"
export * from "./stock-order-all.vue?vue&type=script&lang=js"
import style0 from "./stock-order-all.vue?vue&type=style&index=0&id=4252f952&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252f952",
  null
  
)

export default component.exports